import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { User } from '@sentry/types';
import { BehaviorSubject } from 'rxjs';
import { ActivityAgendaItemV2, AgendaItem } from '../passes-teacher-v2.component';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'sp-teacher-home-activity',
	template: `
		<div class="classes-container tw-mb-5">
			<div class="class-info">
				<sp-collapsible-card
					[collapsible]="true"
					[collapsed]="agendaItem.collapsed"
					[collapsedBubbleText]="
						agendaItem.passes.size === 0
							? ''
							: agendaItem.passes.size === 1
							? agendaItem.passes.size + ' Upcoming Pass'
							: agendaItem.passes.size + ' Upcoming Passes'
					"
					(titleRightContainerClicked)="clickRight(agendaItem.data.activity.id, agendaItem.collapsed)">
					<div sp-collapsible-card-header>
						<div class="class-info-header class-info-header-hover">
							<span class="tw-truncate" [ngClass]="{ 'with-upcoming-passes': agendaItem.passes.size > 0 }">{{ agendaItem.data.activity.name }}</span>
							<img src="./assets/Twinkie (Blue-Gray).svg" alt="right-icon" [style.width]="'16px'" [style.height]="'16px'" />
						</div>
					</div>
					<div sp-collapsible-card-subheader class="-tw-ml-[14px]">
						<div class="tw-text-lg tw-font-normal tw-pt-2">
							{{ agendaItem.start_time.toDate() | date : 'h:mm a' }} - {{ agendaItem.end_time.toDate() | date : 'h:mm a' }}
						</div>
					</div>

					<div collapsible-card-content style="width: 100%">
						<div class="tw-mb-4 -tw-ml-[14px]">
							<app-round-input
								[width]="'100%'"
								[color]="'#1F195E'"
								[fontSize]="'18px'"
								[height]="'32px'"
								[noFocus]="true"
								[boxShadow]="false"
								(ontextupdate)="onStudentActivitySearch($event, agendaItem)"
								(blurEvent)="isSearchingStudents = false"
								[placeholder]="'Search students'">
							</app-round-input>
						</div>
						<div class="student-list -tw-mx-[14px]">
							<div class="tw-text-center tw-h-10 tw-text-gray-500" *ngIf="isSearchingStudents && studentSearchResults.value.length === 0">
								No students found
							</div>

							<sp-student-list-item
								*ngFor="let student of studentSearchResults.value"
								[student]="student.user ? student.user : student"
								class="student-item">
							</sp-student-list-item>
						</div>
					</div>
				</sp-collapsible-card>
			</div>
		</div>
	`,
})
export class TeacherHomeActivityComponent implements OnInit {
	@Input() agendaItem!: AgendaItem & ActivityAgendaItemV2;
	@Input() clickRight: (id: number, collapsed: boolean) => void = () => {};

	studentSearchResults: BehaviorSubject<User[]> = new BehaviorSubject<User[]>([]);
	isSearchingStudents = false;

	constructor() {}

	ngOnInit(): void {
		this.studentSearchResults.next(this.agendaItem.data.students);
	}

	onStudentActivitySearch(value: string, item: ActivityAgendaItemV2): void {
		const searchValue = value.toLowerCase();
		this.isSearchingStudents = true;
		this.studentSearchResults.next(item.data.students.filter((student) => student.display_name.toLowerCase().includes(searchValue)));
	}
}
